import { render, staticRenderFns } from "./OrderDeleteModal.vue?vue&type=template&id=141ca604&scoped=true"
import script from "./OrderDeleteModal.vue?vue&type=script&lang=js"
export * from "./OrderDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ca604",
  null
  
)

export default component.exports